module.exports = __webpack_public_path__ + "img/detBannerGreen.7675a1c8.jpg";